import { usePage } from '@inertiajs/react';
import { Fragment } from 'react';
import StarIcon from '~/components/ui/icons/StarIcon';
import TopBanner from '~/components/ui/TopBanner';

export default function SaleBanner() {
  const { sale_banner_message: saleBannerMessage } = usePage<{
    sale_banner_message: string[];
  }>().props;

  if (!saleBannerMessage) {
    return null;
  }

  return (
    <TopBanner variant="warm">
      <div className="flex gap-2 overflow-hidden -translate-x-24">
        {Array(8)
          .fill(null)
          .map((_, index) => (
            // eslint-disable-next-line @eslint-react/no-array-index-key -- Repeated banner rows never reorder.
            <div key={index} className="flex gap-2 whitespace-nowrap flex-1 items-center uppercase">
              {saleBannerMessage.map((message, messageIndex) => (
                // eslint-disable-next-line @eslint-react/no-array-index-key -- Configured messages form a static list and may repeat.
                <Fragment key={messageIndex}>
                  <span>{message}</span>
                  <StarIcon className="text-white" />
                </Fragment>
              ))}
            </div>
          ))}
      </div>
    </TopBanner>
  );
}
